<div class="sm-container">
  <span>{{ 'common.systemError' | translate }}</span>
</div>